import { useSelector } from 'react-redux';

import { useFBOauthTokensCRUDActions } from '@mm/state/actions/FBOauthTokensCRUDActions';
import { hasFBOauthTokensSelector } from '@mm/state/selectors/fbOauthTokensSelectors';
import { hasConnectedRealFacebookPageSelector } from '@mm/state/selectors/userSelector';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';

export const useFBConnect = () => {
  const isUserPageConnected = useSelector(hasConnectedRealFacebookPageSelector);
  const hasFBOauthTokens = useSelector(hasFBOauthTokensSelector);
  const hasFBConnection = isUserPageConnected || hasFBOauthTokens;
  const fbOauthTokensCRUDActions = useFBOauthTokensCRUDActions();
  const facebookPageId = useSelector(activeFacebookPageIdSelector);

  const removeToken = async () => {
    await fbOauthTokensCRUDActions.disable({ facebookPageId });
  };

  return {
    removeToken,
    hasFBConnection,
    hasFBOauthTokens,
  };
};
